import { DomSanitizer, Meta, Title } from '@angular/platform-browser';

import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import {
  GetMorePublicPublications,
  GetPublicPublications,
} from 'app/redux/actions/publication.actions';

import { Observable } from 'rxjs';
import {
  DEAFULT_IMAGE_ENTITY,
  DEAFULT_IMAGE_PUBLICATION,
  DEAFULT_SHIELD_COMPETITION,
  DEAFULT_SHIELD_TEAM,
  TYPE_COMPETITION_TEAM,
} from '@shared/constants';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EntityState } from 'app/redux/state/entity.state';
import { Entity } from 'app/graphql/interfaces/entityModel';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TypeService } from 'app/graphql/services/type.service';
import { Publication } from 'app/graphql/types';
import { SharedService } from '@shared/services/shared.service';
import { PublicationService } from 'app/graphql/services/publication.service';

@UntilDestroy()
@Component({
  selector: 'widget-publication-tile',
  styleUrls: ['./widget-publication-tile.component.scss'],
  templateUrl: './widget-publication-tile.component.html',
})
export class WidgetPublicationTileComponent implements OnInit {
  @Input() publication: Publication;
  @Input() first: Boolean;
  @Input() widget: Boolean;

  body = null;
  defaultImagePublication = DEAFULT_IMAGE_PUBLICATION;
  defaultShieldCompetition = DEAFULT_SHIELD_COMPETITION;
  TYPE_COMPETITION_TEAM = TYPE_COMPETITION_TEAM;
  defaultShieldTeam = DEAFULT_SHIELD_TEAM;
  entity: Entity = this.store.snapshot().Entity.entity;

  options: any[] = [];
  social: any;

  constructor(
    private store: Store,
    public sharedService: SharedService,
    public translate: TranslateService,
    public typeService: TypeService
  ) {}

  ngOnInit() {
    this.social =
      this.publication.socialTypeId != null
        ? this.typeService.getType(this.publication.socialTypeId)
        : null;
    if (this.social != null && this.social.langKey != null)
      this.social = { ...this.social, icon: this.typeService.getIcon(this.social.langKey) };
  }
}
